<template>
  <div id="app">
    <domain-move-notice
      v-if="showDomainMoveNotice"
      :new-site-url="newSiteUrl"
    />
    <div
      v-else
      v-cloak
    >
      <router-view/>
    </div>
  </div>
</template>

<script>
  import DomainMoveNotice from '@/components/DomainMoveNotice';

  export default {
    name: 'App',
    components: {
      DomainMoveNotice,
    },
    computed: {
      showDomainMoveNotice() {
        const { hostname, port } = window.location;

        return hostname === 'therapeuticcolorindicator.com'
          || hostname === 'www.therapeuticcolorindicator.com'
          || (hostname === 'localhost' && port === '5173');
      },
      newSiteUrl() {
        if (window.location.hostname === 'localhost') {
          return 'http://localhost:5174';
        }

        return 'https://therapeuticcolorindicator.netlify.app';
      },
    },
  };
</script>

<style>
  @import '../node_modules/bootstrap/dist/css/bootstrap.css';
  @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';

  [v-cloak] {
    display: none;
  }

  #app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    font-family: 'Open Sans', serif;
    font-size: 1rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 60px;*/
  }

  html,
  body {
    height: 100%;
  }

</style>
